import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, NavParams, Tabs, Tab, App, MenuController } from 'ionic-angular';
//Pages
import { HomePage } from '../home/home';
import { PalestrantesPage } from '../palestrantes/palestrantes';
import { AgendaPage } from '../agenda/agenda';
import { AulasPage } from '../aulas/aulas';
import { AtividadePage } from './../atividade/atividade';
import { ExpositoresPage } from '../expositores/expositores';
//Providers
import { ConfigProvider } from '../../providers/config-provider';
import { UtilProvider } from '../../providers/util-provider';
import { StorageProvider } from '../../providers/storage-provider';
//Models
import { Congresso } from '../../models/congresso.model';
import { Lecturer } from '../../models/lecturer.model';
import { Expositor } from './../../models/expositor/expositor.model';
import { Area } from './../../models/area.model';
import { Day } from './../../models/day.model';
//Components
import { ThemeHelperComponent } from '../../components/theme-helper/theme-helper.component';
import { ExpositorPage } from '../expositor/expositor';

@Component({
    templateUrl: 'tabs.html'
})
export class TabsPage implements OnInit {

    @ViewChild(ThemeHelperComponent) themeHelper: ThemeHelperComponent;

    isDesktop: boolean;
    page: number;

    tab1Root: any = HomePage;
    tab2Root: any = AulasPage;
    tab3Root: any = AgendaPage;
    tab4Root: any = PalestrantesPage;
    tab5Root: any = ExpositoresPage;
    tab6Root: any = AulasPage;

    public congresso: Congresso;
    public congressos: Array<Congresso>
    public isCurrent: boolean = false;
    public isActualYear: boolean = true;
    private expositorId: number = null;
    private atividadeId: number = null;
    private goToSimposios: boolean = false;
    private area: string = "Geral";
    private activityType: string = "SPO";

    constructor(public params: NavParams,
        private menuCtrl: MenuController,
        public navCtrl: NavController,
        public config: ConfigProvider,
        public storageProvider: StorageProvider,
        public app: App,
        public utilProvider: UtilProvider) {

        var paramId = location.href.split('#')[1] ? location.href.split('#')[1].split('/')[2] : null;

        this.expositorId = paramId && location.href.split('#')[1].split('/')[1] === "expositores" ? Number(paramId) : null;
        this.atividadeId = paramId && location.href.split('#')[1].split('/')[1] === "aulas" ? Number(paramId) : null;
        this.goToSimposios = location.href.split('#')[1] ? location.href.split('#')[1].split('/')[1] === "simposios" : false;
        

        if (this.expositorId)
            this.navigateToExpositor(this.expositorId);
        else if (this.atividadeId)
            this.navigateToAtividade(this.atividadeId);
        else if(this.goToSimposios)
            this.navigateToSimposios();

        this.utilProvider.isDesktopView().subscribe(isDesktop => {
            this.isDesktop = isDesktop;
            if (this.isDesktop) {
                let elem = <HTMLElement>document.querySelector(".tabbar");
                if (elem != null) {
                    elem.style.display = 'none';
                }
            }
        });
    }

    ngOnInit() {
        this.init();
    }

    init() {

        this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
        this.congressos = JSON.parse(localStorage.getItem('congressos')) as Array<Congresso>;

        this.isCurrent = this.congresso.Liberado || this.congresso.Ano == (this.congressos[0] ? this.congressos[0].Ano : this.config.ANO_ATUAL);
        this.isActualYear = (this.congressos[0] ? this.config.ANO_ATUAL == this.congresso.Ano || this.congresso.Liberado : true)

        this.page = this.params.get('id');
        //this.utilProvider
    }

    setIdex(tab: Tab) {

        this.page = tab.index != undefined ? tab.index : 2;
    }

    backToCurrentCongress() {
        this.utilProvider.loadingShow();
        this.setCongress(this.congressos[0].Ano);

        let atuais = JSON.parse(localStorage.getItem('programacaoAtual'));
        if (atuais[0].Day) {
            this.storageProvider.set('atividadesDia', atuais);
            this.storageProvider.set('atividadesArea', []);
        }
        if (atuais[0].Area) {
            this.storageProvider.set('atividadesArea', atuais);
            this.storageProvider.set('atividadesDia', []);
        }

        let palestrantes = new Array<Lecturer>();
        atuais.forEach((x) => {
            Array.prototype.push.apply(palestrantes, x.Palestrantes);
        });

        localStorage.setItem('palestrantes', palestrantes ? JSON.stringify(palestrantes.filter((thing, index, self) => self.findIndex((t) => { return t.Nome === thing.Nome; }) === index).sort()) : '');
        this.isCurrent = true;
        this.utilProvider.loadingHide();
    }

    setCongress(ano: any) {

        let congressos = JSON.parse(localStorage.getItem('congressos')) as Array<Congresso>;
        let congresso = congressos.filter(x => x.Ano == ano)[0] as Congresso
        localStorage.setItem('congresso', congresso ? JSON.stringify(congresso) : "");

        this.setColors(congresso);
        let tab = this.app.getRootNav().getActiveChildNav();
        this.navCtrl.setRoot(TabsPage, { id: tab.selectedIndex });

    }

    setColors(congresso: Congresso) {
        if (congresso.CorPrimaria) {
            this.themeHelper.setProperty('primary', congresso.CorPrimaria);
            this.themeHelper.setProperty('primary-lower-op', this.utilProvider.hexToRgbA(congresso.CorPrimaria, 0.8));
            this.themeHelper.setProperty('primary-high-op', this.utilProvider.hexToRgbA(congresso.CorPrimaria, 0.45));
        }
        if (congresso.CorSecundaria) {
            this.themeHelper.setProperty('secondary', congresso.CorSecundaria);
            this.themeHelper.setProperty('secondary-lower-op', this.utilProvider.hexToRgbA(congresso.CorSecundaria, 0.8));
        }

        if (congresso.CorTerciaria) {
            this.themeHelper.setProperty('tertiary', congresso.CorTerciaria);
            this.themeHelper.setProperty('tertiary-lower-op', this.utilProvider.hexToRgbA(congresso.CorTerciaria, 0.8));
            this.themeHelper.setProperty('tertiary-lower-op', this.utilProvider.hexToRgbA(congresso.CorTerciaria, 0.8));
        }
    }

    getOverlayPosition() {
        if (!this.utilProvider.isPhone() && !this.utilProvider.isTablet())
            return 't-60';

        return this.utilProvider.getPlatform() == 'ios' ? 't-60' : 't-44';
    }

    goTo(tabId: number) {

        this.navCtrl.setRoot(TabsPage, { id: tabId, tabIndex: tabId });

    }

    toggleMenu() {
        this.menuCtrl.toggle();
    }

    navigateToExpositor(id: number) {
        let exp = new Expositor();
        exp.Id = id;
        this.navCtrl.push(ExpositorPage, {
            expositor: exp,
        });

        var originalURL = location.href.split('#')[0];
        window.history.pushState("", "", originalURL);
    }

    navigateToAtividade(id: number) {
        this.navCtrl.push(AtividadePage, { id: id })

        var originalURL = location.href.split('#')[0];
        window.history.pushState("", "", originalURL);
    }

    navigateToSimposios() {
        this.navCtrl.push(AulasPage, { area: this.area, type: this.activityType })

        var originalURL = location.href.split('#')[0];
        window.history.pushState("", "", originalURL);
    }
}





// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts